import {
  useBlockProps,
  BlockControls,
  InnerBlocks,
} from "@wordpress/block-editor";
import { ToolbarGroup, Button as WPButton } from "@wordpress/components";
import { t } from "drupal";
import SidePanel from "./sidePanel.js";
import { useSelect } from "@wordpress/data";
import { store as blockEditorStore } from "@wordpress/block-editor";
import CustomRepater from "./customRepeater.js";

function Edit({ attributes, setAttributes, clientId }) {
  const { backgroundColorClass } = attributes;

  const onChangeBackgroundColorClass = (className) =>
    setAttributes({ backgroundColorClass: className });

  const ALLOWED_BLOCKS = [
    "core/group",
    "core/block",
    "core/heading",
    "core/paragraph",
    "core/image",
    "core/list",
    "core/spacer",
    "core/columns",
    "core/space",
    "deohs-gutenberg-blocks/deohs-button",
    "deohs-gutenberg-blocks/deohs-biobox",
    "deohs-gutenberg-blocks/deohs-card-horizontal",
    "deohs-gutenberg-blocks/deohs-card-vertical",
    "deohs-gutenberg-blocks/deohs-card-square",
    "deohs-gutenberg-blocks/deohs-card-no-image",
    "deohs-gutenberg-blocks/deohs-image-backed-card",
    "deohs-gutenberg-blocks/deohs-grid-card-profile-group",
    "deohs-gutenberg-blocks/deohs-card-group",
    "deohs-gutenberg-blocks/deohs-fast-facts",
    "deohs-gutenberg-blocks/deohs-pull-quote",
    "deohs-gutenberg-blocks/deohs-profile-card",
    "deohs-gutenberg-blocks/deohs-image-backed-card",
    "deohs-gutenberg-blocks/deohs-accordion-container"
  ];


  const BLOCK_LABELS = {
    "deohs-gutenberg-blocks/deohs-button": "Button block",
    "deohs-gutenberg-blocks/deohs-biobox": "Biobox",
    "deohs-gutenberg-blocks/deohs-card-horizontal": "Horizontal card",
    "deohs-gutenberg-blocks/deohs-card-vertical": "Vertical card",
    "deohs-gutenberg-blocks/deohs-card-square": "Square card",
    "deohs-gutenberg-blocks/deohs-card-no-image": "No-image card",
    "deohs-gutenberg-blocks/deohs-image-backed-card": "Image-backed card",
    "deohs-gutenberg-blocks/deohs-grid-card-profile-group": "Grid profile group",
    "deohs-gutenberg-blocks/deohs-grid-card-group": "Grid card group",
    "deohs-gutenberg-blocks/deohs-fast-facts": "Fast facts",
    "deohs-gutenberg-blocks/deohs-pull-quote": "Pull quote",
    "deohs-gutenberg-blocks/deohs-profile-card": "Profile card",
  };

  const invalidBlocks = useSelect((select) => {
    const { getBlocks } = select(blockEditorStore);
    const innerBlocks = getBlocks(clientId);

    return innerBlocks
      .filter((block) => {
        const { name, attributes } = block;

        switch (name) {
          case "deohs-gutenberg-blocks/deohs-button":
            return attributes.ctaError || attributes.ctaUrlError;
          case "deohs-gutenberg-blocks/deohs-profile-card":
            return (
              attributes.titleError ||
              attributes.profileNameError ||
              attributes.linkTextError ||
              attributes.linkUrlError
            );
          case "deohs-gutenberg-blocks/deohs-card-horizontal":
          case "deohs-gutenberg-blocks/deohs-card-vertical":
          case "deohs-gutenberg-blocks/deohs-card-square":
            return (
              attributes.titleError ||
              attributes.imageError ||
              attributes.ctaError ||
              attributes.ctaUrlError
            );
          case "deohs-gutenberg-blocks/deohs-card-no-image":
            return (
              attributes.titleError || attributes.ctaError || attributes.ctaUrlError
            );
          case "deohs-gutenberg-blocks/deohs-image-backed-card":
            return (
              attributes.linkTextError ||
              attributes.linkUrlError ||
              attributes.imageError
            );
          case "deohs-gutenberg-blocks/deohs-fast-facts":
            return (
              attributes.titleError ||
              attributes.numOfFactsError ||
              attributes.iconError
            );
          case "deohs-gutenberg-blocks/deohs-pull-quote":
            return attributes.quotationError;
          default:
            return false;
        }
      })
      .map((block) => BLOCK_LABELS[block.name] || block.name); // Map to readable labels
  }, [clientId]);



  return (
    <div {...useBlockProps()}>
      {/* Block Controls */}
      <BlockControls>
        <ToolbarGroup>
          <WPButton
            label={t("Full-Width Container Settings")}
            icon="text"
            disabled
          />
        </ToolbarGroup>
      </BlockControls>

      {invalidBlocks.length > 0 && (
        <div className="parent-block-container-error">
          <p>The following blocks have errors and must be fixed before saving:</p>
          <ul>
            {invalidBlocks.map((blockName, index) => (
              <li key={index}>{blockName}</li>
            ))}
          </ul>
        </div>
      )}


      <div className={`fw-section ${backgroundColorClass}`}>
        <div className="row">
          <div className="col-12">
            <InnerBlocks
              allowedBlocks={ALLOWED_BLOCKS}
              templateLock={false}
              // Turn off the default one
              renderAppender={false}

            />
          </div>
        </div>
      </div>
      <CustomRepater/>
      <SidePanel
        onChangeBackgroundColorClass={onChangeBackgroundColorClass}
      />
    </div>
  );
}

export default Edit;
